export default __webpack_public_path__ + "static/funding-662499a4c53f2482649faa1ae6f5569a.png";